(function () {
  /* =========================================================
     Desktop mega menu (robust init + ATC + L3 toggle)
     ========================================================= */
  const megaRootSelector = '[data-mtt-products-mega]';

  async function addToCart(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(qty) })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  function openCartDrawerIfPresent() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return true;
    }
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      cartIcon.click();
      return true;
    }
    return false;
  }

  function initMega(root) {
    const links = root.querySelectorAll('[data-mtt-collection-handle]');
    const panels = root.querySelectorAll('[data-mtt-products-panel]');
    if (!links.length || !panels.length) return;

    function activate(handle) {
      panels.forEach((p) => {
        const isActive = p.getAttribute('data-mtt-products-panel') === handle;
        if (isActive) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });

      links.forEach((a) => {
        a.classList.toggle('is-active', a.getAttribute('data-mtt-collection-handle') === handle);
      });

      const activeLink = Array.from(links).find(
        (a) => a.getAttribute('data-mtt-collection-handle') === handle
      );
      const title = activeLink?.getAttribute('data-mtt-collection-title') || '';
      const titleEl = root.querySelector('[data-mtt-featured-title]');
      if (titleEl) titleEl.textContent = title;
    }

    // store on node so we can re-trigger later if theme resets hidden attrs
    root.__mttActivate = activate;

    // Default: activate first link if nothing visible
    const anyVisible = root.querySelector('[data-mtt-products-panel]:not([hidden])');
    if (!anyVisible) {
      const firstHandle = links[0].getAttribute('data-mtt-collection-handle');
      if (firstHandle) activate(firstHandle);
    }

    // Hover/focus switch
    links.forEach((a) => {
      const handle = a.getAttribute('data-mtt-collection-handle');
      a.addEventListener('mouseenter', () => activate(handle));
      a.addEventListener('focus', () => activate(handle));
    });

    // ATC within mega
    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-mtt-atc]');
      if (!btn) return;

      e.preventDefault();

      const variantId = btn.getAttribute('data-mtt-atc');
      if (!variantId) return;

      btn.disabled = true;
      const oldText = btn.textContent;
      btn.textContent = 'Adding…';

      try {
        await addToCart(variantId, 1);
        btn.textContent = 'Added';
        openCartDrawerIfPresent();
        setTimeout(() => {
          btn.textContent = oldText || 'Add to cart';
          btn.disabled = false;
        }, 900);
      } catch (err) {
        console.error(err);
        btn.textContent = 'Error';
        setTimeout(() => {
          btn.textContent = oldText || 'Add to cart';
          btn.disabled = false;
        }, 1200);
      }
    });
  }

  function scanAndInitMegas() {
    document.querySelectorAll(megaRootSelector).forEach((root) => {
      if (root.__mttInited) return;
      root.__mttInited = true;
      initMega(root);
    });
  }

  document.addEventListener('DOMContentLoaded', scanAndInitMegas);

  // If Dawn injects/rebuilds mega menu after load
  const mo = new MutationObserver(() => scanAndInitMegas());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Each time user hovers into mega area, ensure a default panel is visible
  document.addEventListener('mouseover', (e) => {
    const root = e.target.closest(megaRootSelector);
    if (!root) return;

    if (!root.__mttInited) {
      root.__mttInited = true;
      initMega(root);
      return;
    }

    const anyVisible = root.querySelector('[data-mtt-products-panel]:not([hidden])');
    if (!anyVisible) {
      const first = root.querySelector('[data-mtt-collection-handle]');
      if (first && root.__mttActivate) {
        root.__mttActivate(first.getAttribute('data-mtt-collection-handle'));
      }
    }
  });

  // Desktop: collapsible L3
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.mtt-l2__toggle');
    if (!btn) return;

    const mega = btn.closest('[data-mtt-products-mega]');
    if (!mega) return;

    e.preventDefault();
    e.stopPropagation();

    const l2 = btn.closest('.mtt-l2');
    if (!l2) return;

    const isCollapsed = l2.classList.toggle('is-collapsed');
    btn.setAttribute('aria-expanded', String(!isCollapsed));
  });

  /* =========================================================
     Mobile drawer products panel
     ========================================================= */
  const cache = new Map();
  let lastActiveSubmenu = null;

  function getPanelEls() {
    const panel = document.querySelector('#mtt-md-products-panel');
    if (!panel) return null;

    const inner = panel.querySelector('.menu-drawer__inner-submenu');
    const backBtn = panel.querySelector('[data-mtt-md-panel-back]');
    const titleEl = panel.querySelector('[data-mtt-md-panel-title]');
    const headingEl = panel.querySelector('[data-mtt-md-panel-heading]');
    const viewAllEl = panel.querySelector('[data-mtt-md-panel-viewall]');
    const grid = panel.querySelector('[data-mtt-md-grid]');
    const loading = panel.querySelector('[data-mtt-md-loading]');
    const empty = panel.querySelector('[data-mtt-md-empty]');

    if (!inner || !backBtn || !grid || !loading || !empty) return null;

    return { panel, inner, backBtn, titleEl, headingEl, viewAllEl, grid, loading, empty };
  }

  function findCurrentlyVisibleSubmenu() {
    const drawer = document.querySelector('#menu-drawer');
    if (!drawer) return null;

    const candidates = Array.from(drawer.querySelectorAll('.menu-drawer__submenu'));
    const visible = candidates.find((el) => {
      if (el.id === 'mtt-md-products-panel') return false;
      const cs = getComputedStyle(el);
      return cs.visibility !== 'hidden' && cs.display !== 'none';
    });

    return visible || null;
  }

  function hideSubmenuPage(el) {
    if (!el) return;

    el.style.visibility = 'hidden';
    el.style.transform = 'translate(100%)';
    el.style.pointerEvents = 'none';

    const inner = el.querySelector('.menu-drawer__inner-submenu');
    if (inner) inner.classList.remove('menu-drawer__inner-submenu--open');
  }

  function restoreSubmenuPage(el) {
    if (!el) return;

    el.style.visibility = '';
    el.style.transform = '';
    el.style.pointerEvents = '';

    const inner = el.querySelector('.menu-drawer__inner-submenu');
    if (inner) inner.classList.add('menu-drawer__inner-submenu--open');
  }

  async function fetchProducts(handle) {
    if (cache.has(handle)) return cache.get(handle);

    const url = `/collections/${encodeURIComponent(handle)}/products.json?limit=250`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Failed to fetch ${handle}: ${res.status}`);

    const json = await res.json();
    const products = json?.products || [];
    cache.set(handle, products);
    return products;
  }

  function buildMobileCard(p) {
    const a = document.createElement('a');
    a.className = 'mtt-mdp-card';
    a.href = `/products/${p.handle}`;

    const img = p.images?.[0]?.src || '';
    const price = p.variants?.[0]?.price || '';

    a.innerHTML = `
      <span class="mtt-mdp-img">${img ? `<img src="${img}&width=360" loading="lazy" alt="${(p.title || '').replace(/"/g, '&quot;')}">` : ''}</span>
      <span class="mtt-mdp-title">${p.title || ''}</span>
      ${price ? `<span class="mtt-mdp-price">$${price}</span>` : ``}
    `;
    return a;
  }

  async function renderPanelProducts(handle, els) {
    els.loading.hidden = false;
    els.empty.hidden = true;
    els.grid.innerHTML = '';

    try {
      const products = await fetchProducts(handle);
      els.loading.hidden = true;

      if (!products.length) {
        els.empty.hidden = false;
        return;
      }

      const frag = document.createDocumentFragment();
      products.forEach((p) => frag.appendChild(buildMobileCard(p)));
      els.grid.appendChild(frag);
    } catch (err) {
      console.error(err);
      els.loading.hidden = true;
      els.empty.hidden = false;
      els.empty.textContent = 'Failed to load products.';
    }
  }

  function openProductsPanel({ handle, title, viewAll }) {
    const els = getPanelEls();
    if (!els) return;

    lastActiveSubmenu = findCurrentlyVisibleSubmenu();
    hideSubmenuPage(lastActiveSubmenu);

    els.panel.hidden = false;
    els.panel.classList.add('mtt-md-products-panel--open');
    els.inner.classList.add('menu-drawer__inner-submenu--open');

    if (els.titleEl) els.titleEl.textContent = title || 'Products';
    if (els.headingEl) els.headingEl.textContent = title || 'Products';
    if (els.viewAllEl) els.viewAllEl.setAttribute('href', viewAll || '#');

    renderPanelProducts(handle, els);

    try {
      els.panel.focus();
    } catch (_) {}
  }

  function closeProductsPanel() {
    const els = getPanelEls();
    if (!els) return;

    els.inner.classList.remove('menu-drawer__inner-submenu--open');
    els.panel.classList.remove('mtt-md-products-panel--open');
    els.panel.hidden = true;

    restoreSubmenuPage(lastActiveSubmenu);
    lastActiveSubmenu = null;
  }

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('[data-mtt-md-panel-back]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      closeProductsPanel();
    },
    true
  );

  function interceptAndOpen(e) {
    const drawer = e.target.closest('#menu-drawer');
    if (!drawer) return;

    const a = e.target.closest('a[data-mtt-md-open-panel]');
    if (!a) return;

    const handle = a.getAttribute('data-mtt-md-collection');
    if (!handle) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    const payload = {
      handle,
      title: a.getAttribute('data-mtt-md-title') || a.textContent?.trim() || 'Products',
      viewAll: a.getAttribute('data-mtt-md-viewall') || a.getAttribute('href') || '#'
    };

    requestAnimationFrame(() => openProductsPanel(payload));
  }

  document.addEventListener('pointerdown', interceptAndOpen, true);
  document.addEventListener('touchstart', interceptAndOpen, { capture: true, passive: false });
  document.addEventListener('click', interceptAndOpen, true);
})();